import { BsPatchCheckFill } from "react-icons/bs";
import "./Experiance.css";

function Experiance() {
  const skills = [
    { name: "ReactJS", level: "Experienced" },
    { name: "NextJS", level: "Experienced" },
    { name: "NodeJS", level: "Experienced" },
    { name: "PHP", level: "Intermediate" },
    { name: "ExpressJS", level: "Experienced" },
    { name: "Typescript", level: "Experienced" },
    { name: "Javascript", level: "Experienced" },
    { name: "HTML", level: "Experienced" },
    { name: "CSS", level: "Experienced" },
    { name: "Tailwind CSS", level: "Experienced" },
    { name: "Material UI", level: "Intermediate" },
    { name: "Framermotion", level: "Intermediate" },
    { name: "Python", level: "Intermediate" },
    { name: "Wordpress", level: "Experienced" },
  ];

  return (
    <section id="experiance">
      <h5>What skills I have</h5>
      <h2>Experience</h2>
      <div className="container experiance__container">
        <div className="experiance__web">
          <div className="experiance__content">
            {skills.map((skill, index) => (
              <article className="experiance__detail" key={index}>
                <BsPatchCheckFill className="experiance__detail-icon" />
                <div>
                  <h4>{skill.name}</h4>
                  <small className="text-light">{skill.level}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experiance;